function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_115",
  "data-name": "Group 115",
  transform: "translate(-652 -485.204)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_111",
  "data-name": "Group 111",
  transform: "translate(652 485)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_129",
  "data-name": "Rectangle 129",
  width: 29,
  height: 3,
  transform: "translate(0 0.204)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_112",
  "data-name": "Group 112",
  transform: "translate(652 492.198)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_130",
  "data-name": "Rectangle 130",
  width: 29,
  height: 4,
  transform: "translate(0 0.006)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_113",
  "data-name": "Group 113",
  transform: "translate(652 499.402)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_131",
  "data-name": "Rectangle 131",
  width: 29,
  height: 4,
  transform: "translate(0 -0.198)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_114",
  "data-name": "Group 114",
  transform: "translate(652 506.604)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_132",
  "data-name": "Rectangle 132",
  width: 29,
  height: 4,
  transform: "translate(0 -0.4)",
  fill: "#fff"
})));

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.34d8fc83.svg";
export { ForwardRef as ReactComponent };